<div class="dvm-fu" [class.dvm-fu-compact]="compact">
  <span class="dvm-fu-title" *ngIf="title && !compact">{{ title }}</span>

  <input #fuInput type="file" [accept]="accept" hidden (change)="onFileSelected($event)" />
  <button
    type="button"
    class="dvm-fu-btn" [ngStyle]="buttonStyle"
    [disabled]="uploading"
    (click)="fuInput.click()"
    [title]="message || buttonLabel"
  >{{ uploading ? '⏳ Uploading…' : '⭱ ' + buttonLabel }}</button>

  <span class="dvm-fu-msg" *ngIf="message && !compact" [title]="message">{{ message }}</span>
  <span class="dvm-fu-hint" *ngIf="targetCount > 0 && !compact">Updates {{ targetCount }} target(s) on upload.</span>
</div>
